import React from "react";
import { Box } from "@mui/system";
import { styles } from "./styles";
import Loader from "components/loader";
import ROUTE_NAMES from "routes/routeNames";
import { ReducersModal } from "utils/modals";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "components/customModal";
import OrderTable from "components/tables/orderTable";
import { useDispatch, useSelector } from "react-redux";
import { dispatchOrderValue, getOrderList } from "./action";
import { Typography } from "@mui/material";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { ORDER_STATUS_DATA } from "utils/constants";

const Order = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch: any = useDispatch();
  const {
    limit,
    page,
    search,
    serviceTypeId,
    isLoading,
    sortedBy,
    sortOrder,
    orderStatus,
    paymentType,
    userId,
    merchantId,
    category,
  } = useSelector((state: ReducersModal) => state.OrderManagementReducer);
  const [internalState, setInternalStates] = React.useState({
    showCreteOrderPopup: false,
  });

  // Dashboard / user-detail deep links pass ?orderStatus=… (& optional merchantId).
  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.has("orderStatus")) return;
    const nextStatus = params.get("orderStatus") || "-1";
    const isKnownStatus = ORDER_STATUS_DATA.some(
      (option) => option.id === nextStatus,
    );
    const nextMerchantId = params.get("merchantId") || "";
    const nextMerchantName = params.get("merchantName") || "";
    dispatch(
      dispatchOrderValue({
        orderStatus: isKnownStatus ? nextStatus : "-1",
        page: 1,
        paymentType: "-1",
        category: "-1",
        userId: "",
        merchantId: nextMerchantId,
        selectedUser: null,
        selectedMerchant: nextMerchantId
          ? ({
              id: nextMerchantId,
              fullName: nextMerchantName || nextMerchantId,
            } as any)
          : null,
        search: "",
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  React.useEffect(() => {
    dispatch(getOrderList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    page,
    limit,
    search,
    serviceTypeId,
    sortedBy,
    sortOrder,
    orderStatus,
    paymentType,
    userId,
    merchantId,
    category,
  ]);

  return (
    <Box>
      <OrderTable
        onAddPress={() => {
          setInternalStates((prev) => ({
            ...prev,
            showCreteOrderPopup: true,
          }));
        }}
      />
      <CustomModal
        title="Create Order For"
        maxWidth={720}
        onClose={() => {
          setInternalStates((prev) => ({
            ...prev,
            showCreteOrderPopup: false,
          }));
        }}
        visible={internalState.showCreteOrderPopup}
      >
        <Box sx={styles.modalContainer}>
          <Box
            component="button"
            type="button"
            sx={styles.choice}
            onClick={() => {
              navigate(ROUTE_NAMES.MAIN_ROUTES.ADD_USER);
            }}
          >
            <Box sx={styles.choiceIcon}>
              <PersonAddAltOutlinedIcon />
            </Box>
            <Typography sx={styles.choiceTitle}>New user</Typography>
            <Typography sx={styles.choiceText}>
              Add someone, then start their order
            </Typography>
          </Box>
          <Box
            component="button"
            type="button"
            sx={styles.choice}
            onClick={() => {
              navigate(`${ROUTE_NAMES.MAIN_ROUTES.CREATE_ORDER}`, {
                state: { showDetails: false },
              });
            }}
          >
            <Box sx={styles.choiceIcon}>
              <GroupsOutlinedIcon />
            </Box>
            <Typography sx={styles.choiceTitle}>Existing user</Typography>
            <Typography sx={styles.choiceText}>
              Start an order for someone already on the platform
            </Typography>
          </Box>
        </Box>
      </CustomModal>
      {isLoading && <Loader />}
    </Box>
  );
};
export default Order;
